import { useMemo } from 'react';

import TabControl from '../../../components/tabs/TabControl';
import { PathsLayouts } from '../../../config/routes';
import Discount from './Discount';
import Partnership from './Partnership';
import Subsidy from './Subsidy';
import Tariff from './Tariff';
// import Tuition from './Tuition';

export default function TariffAndTuition() {
  const tabsPrefix = 'tariffAndTuition.tabs';
  const tabs = useMemo(
    () => [
      // { name: 'tuitions', content: <Tuition /> }, POSIBLEMENTE BORRAR CON TODO SU CONTENIDO CUANDO SE REVISE EL FLUJO NUEVO
      { name: 'tariff', content: <Tariff /> },
      { name: 'discounts', content: <Discount /> },
      { name: 'subsidies', content: <Subsidy /> },
      { name: 'partnerships', content: <Partnership /> },
    ],
    [],
  );

  return (
    <>
      <TabControl
        tabsPrefix={tabsPrefix}
        tabs={tabs}
        path={PathsLayouts.tariffAndTuiton}
      />
    </>
  );
}
